import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { EVENTS } from '@/analytics/consts';
import { useAnalytics } from '@/analytics/useAnalytics';
import { useCreateGoal, usePatchGoal, getListGoalsQueryKey } from '@/api/generated';

const useGoalsAddEdit = () => {
  const { captureEvent } = useAnalytics();
  const { mutateAsync: mutateCreateGoal } = useCreateGoal();
  const { mutateAsync: mutatePatchGoal } = usePatchGoal();
  const queryClient = useQueryClient();

  const onEditGoal = useCallback(
    (value: string, id: string) => {
      mutatePatchGoal({ id, data: { title: value } });
      captureEvent(EVENTS.GOAL_EDITED, {
        id,
        title: value
      });
    },
    [mutatePatchGoal]
  );

  const onAddGoal = useCallback(
    async (value: string, dueDate: string) => {
      const response = await mutateCreateGoal({
        data: {
          title: value,
          dueDate: dueDate
        }
      });

      queryClient.setQueryData(getListGoalsQueryKey(), (old: any) => {
        if (!old?.items) return old;
        return {
          ...old,
          items: [...old.items, response?.items?.[0]]
        };
      });
      captureEvent(EVENTS.GOAL_CREATED, {
        goal: response?.items?.[0]
      });

      return response?.items?.[0].id;
    },
    [mutateCreateGoal, queryClient]
  );

  return { onEditGoal, onAddGoal };
};

export default useGoalsAddEdit;
